// extracted by mini-css-extract-plugin
export default {"addNewModuleButtonWrapper":"SiteModulesList_addNewModuleButtonWrapper__Sw0QL","addNewModuleButton":"SiteModulesList_addNewModuleButton__po4dy"};